const SVGSprite = () => {
  return (
    <svg style={{ display: 'none' }}>
      <symbol id="ico-close" viewBox="0 0 10 10">
        <rect x="-1" y="4" transform="matrix(0.7071 0.7071 -0.7071 0.7071 5 -2.0711)" width="11.9" height="2" />
        <rect x="-1" y="4" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 12.0711 5)" width="11.9" height="2" />
      </symbol>
      <symbol id="ico-shopping-bag" viewBox="0 0 20 20">
        <path d="M18.4 3.32h-4.31a4.11 4.11 0 00-8.09 0H1.72V20H18.4zM10.06.91a3.22 3.22 0 013.1 2.41H7A3.23 3.23 0 0110.06.91zm7.43 18.18H2.63V4.23H6V6.1h.91V4.23h6.4V6.1h.91V4.23h3.32z" />
      </symbol>
      <symbol id="ico-arrow-left" viewBox="0 0 6.1 7">
        <path d="M2.63 7l.61-.48-2-2.64H6.1V3.1H1.2L3.26.48 2.64 0 .09 3.26a.37.37 0 000 .48z" />
      </symbol>
      <symbol id="ico-play" viewBox="0 0 31.5 36.37">
        <path d="M30.5 18.19l-15 8.66-15 8.66V.87l15 8.66 15 8.66z" />
      </symbol>
      <symbol id="ico-fullscreen" viewBox="0 0 17 17">
        <path d="M0 7V0h7v2H2v5zm10-7h7v7h-2V2h-5zm7 10v7h-7v-2h5v-5zM7 17H0v-7h2v5h5z" />
      </symbol>
      <symbol id="ico-filters" viewBox="0 0 32 32">
        <path d="M28,9H11a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
        <path d="M7,9H4A1,1,0,0,1,4,7H7A1,1,0,0,1,7,9Z" />
        <path d="M21,17H4a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z" />
        <path d="M11,25H4a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Z" />
        <path d="M9,11a3,3,0,1,1,3-3A3,3,0,0,1,9,11ZM9,7a1,1,0,1,0,1,1A1,1,0,0,0,9,7Z" />
        <path d="M23,19a3,3,0,1,1,3-3A3,3,0,0,1,23,19Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,23,15Z" />
        <path d="M13,27a3,3,0,1,1,3-3A3,3,0,0,1,13,27Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,13,23Z" />
        <path d="M28,17H25a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z" />
        <path d="M28,25H15a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
      </symbol>
    </svg>
  )
}
export default SVGSprite
